const to = sessionStorage;

export const setAccountToken = (at) => to.setItem("urc-token", at);
export const getAccountToken = () => to.getItem("urc-token");

export const setAccountName = (Name) => to.setItem("urc-name", Name);
export const getAccountName = () => to.getItem("urc-name");

export const setUserGroup = (group) => to.setItem("user-group", group);
export const getUserGroup = () => to.getItem("user-group");

export const setUserId = (id) => to.setItem("user-id", id);
export const getUserId = () => to.getItem("user-id");

export const setUserDistributorId = (id) =>
  to.setItem("user-distributor-id", id);
export const getUserDistributorId = () => to.getItem("user-distributor-id");

export const setUserDealerId = (id) => to.setItem("user-dealer-id", id);
export const getUserDealerId = () => to.getItem("user-dealer-id");

export const setUserAccessRoles = (uar) => to.setItem("user-access-roles", uar);
export const getUserAccessRoles = () => to.getItem("user-access-roles");

export const clearTempStorage = () => to.clear();
